<template>
    <div>
        <el-popover
            ref="popover"
            placement="bottom"
            trigger="click"
        >
            <template #reference>
                <button class="btn btn--middle btn--border-bg btn--with-icon--right btn--border-radius--50 button">
                    <span class="button__text">{{ $lang(selectedCategory) }}</span>
                    <svg class="button__arrow" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.99997 8.35018C4.82075 8.35018 4.64155 8.28175 4.50492 8.14518L0.205141 3.84536C-0.0683805 3.57184 -0.0683805 3.12837 0.205141 2.85496C0.478552 2.58155 0.921933 2.58155 1.19548 2.85496L4.99997 6.65968L8.80449 2.85509C9.07801 2.58168 9.52135 2.58168 9.79474 2.85509C10.0684 3.1285 10.0684 3.57197 9.79474 3.84549L5.49503 8.14531C5.35832 8.28191 5.17913 8.35018 4.99997 8.35018Z" fill="#00B4FF"/>
                    </svg>

                </button>
            </template>

            <template>
                <ul class="list">
                    <li
                        class="item"
                        v-for="(item, index) in items"
                        :key="index"
                        @click="onClickItem(item, $event)"
                    >
                        {{ $lang(item.name) }}
                    </li>
                </ul>
            </template>
        </el-popover>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

const HISTORY_STATUS = window.laravel.historyStatus;
export default {
    name: 'WelcomePagesCategory',
    data() {
        return {
            items: [
                {
                    id: null,
                    name: 'status.all.pages',
                },
                {
                    id: HISTORY_STATUS.famous,
                    name: 'status.famous',
                },
                {
                    id: HISTORY_STATUS.military,
                    name: 'status.military',
                },
                {
                    id: HISTORY_STATUS.interesting,
                    name: 'status.interesting',
                },
            ],
        };
    },
    computed: {
        ...mapGetters('welcome', [
            'historyStatusId',
        ]),
        selectedCategory() {
            let status = '';

            switch (this.historyStatusId) {
                case HISTORY_STATUS.famous:
                    status = 'status.famous';
                    break;
                case HISTORY_STATUS.military:
                    status = 'status.military';
                    break;
                case HISTORY_STATUS.interesting:
                    status = 'status.interesting';
                    break;
                default:
                    status = 'status.all.pages'
            }

            return status;
        },
    },
    methods: {
        ...mapMutations('welcome', [
            'setHistoryStatusId',
        ]),
        ...mapActions('welcome', [
            'getPages',
        ]),
        onClickItem(item, event) {
            this.setHistoryStatusId(item.id);
            this.getPages();
            this.$refs.popover.doClose();
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
.button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem;
    font-size: 1.6rem;
    &:hover {
        background: unset;
        color: $color-secondary;
    }
}
.button__arrow {
    width: 10px;
    height: 11px;
}
.list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.item {
    cursor: pointer;
}
</style>
